import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { ClipboardList, Activity, Users, TrendingUp } from 'lucide-react';
const values = [{
  icon: ClipboardList,
  title: 'Planificación personalizada',
  description: 'Programas diseñados específicamente para tus objetivos y nivel actual, ajustados semana a semana.'
}, {
  icon: Activity,
  title: 'Seguimiento constante',
  description: 'Monitoreo continuo de tu progreso, técnica y adaptación al entrenamiento para garantizar resultados.'
}, {
  icon: Users,
  title: 'Equipo interdisciplinario',
  description: 'Profesionales del deporte, kinesiología y nutrición trabajando juntos para tu máximo rendimiento.'
}, {
  icon: TrendingUp,
  title: 'Resultados medibles',
  description: 'Evaluaciones periódicas objetivas para que veas tu evolución con datos reales, no solo sensaciones.'
}];
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.2
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 30
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6,
      ease: 'easeOut'
    }
  }
};
export function AboutSection() {
  return <section id="nosotros" className="py-24 bg-kiron-dark relative" data-id="element-13">
      <div className="max-w-7xl mx-auto px-6" data-id="element-14">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="mb-16" data-id="element-15">
          <h2 className="text-4xl md:text-5xl font-oswald font-bold text-white mb-4" data-id="element-16">
            Por qué <span className="text-kiron-teal" data-id="element-17">Kiron</span>
          </h2>
          <div className="w-20 h-1 bg-kiron-teal" data-id="element-18"></div>
        </motion.div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-19">
          {values.map((value, index) => <motion.div key={index} variants={itemVariants} className="bg-kiron-darker p-8 border-l-4 border-kiron-teal hover:bg-[#222] transition-colors duration-300 group" data-id="element-20">
              <div className="mb-6 inline-block p-3 bg-kiron-black rounded-sm group-hover:bg-kiron-teal group-hover:text-kiron-black transition-colors duration-300" data-id="element-21">
                <value.icon size={32} className="text-kiron-teal group-hover:text-kiron-black" data-id="element-22" />
              </div>
              <h3 className="text-xl font-oswald font-bold text-white mb-3 tracking-wide" data-id="element-23">
                {value.title}
              </h3>
              <p className="text-gray-400 font-light leading-relaxed" data-id="element-24">
                {value.description}
              </p>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}